import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth tokens live only in the backend's httpOnly `session_token` cookie — never in
// localStorage/sessionStorage. `hy_auth` is a readable, non-sensitive marker cookie the
// backend sets alongside it so the SPA can skip a pointless /auth/me call when logged out.
const AUTH_MARKER = "hy_auth";

export const hasAuthMarker = () =>
  document.cookie.split("; ").some((c) => c.startsWith(`${AUTH_MARKER}=`));

export const clearAuthMarker = () => {
  // attributes mirror the backend's cookie so every browser matches and clears it
  document.cookie = `${AUTH_MARKER}=; Max-Age=0; path=/; Secure; SameSite=None`;
};

export const api = axios.create({ baseURL: API, withCredentials: true });

export const money = (n) => {
  const v = Number(n) || 0;
  return new Intl.NumberFormat("en-IN", {
    style: "currency", currency: "INR",
    minimumFractionDigits: Number.isInteger(v) ? 0 : 2,
    maximumFractionDigits: Number.isInteger(v) ? 0 : 2,
  }).format(v);
};

export const regCode = (n) => `HYLUNER REGISTRY #${String(n).padStart(4, "0")}`;

export const EDITION_STYLE = {
  GENESIS: "text-amber-50 bg-amber-400/15 border-amber-300",
  SIGNATURE: "text-amber-100 bg-amber-600/20 border-amber-600",
  COLLECTOR: "text-indigo-100 bg-indigo-600/20 border-indigo-600",
  CELESTIAL: "text-emerald-50 bg-emerald-600/20 border-emerald-600",
};
